import { render, staticRenderFns } from "./StreetCreateOrUpdate.vue?vue&type=template&id=50132a22&"
import script from "./StreetCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./StreetCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports